import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PractitionerWorkspaceNav.css';

const navItems = [
  { id: 'dashboard', label: 'Dashboard', route: '/app/practitioner-dashboard' },
  { id: 'patients', label: 'Patients', route: '/app/practitioners' },
  { id: 'offerings', label: 'Offerings', route: '/app/practitioners/offerings' }
];

const preloadPractitionerRoute = (route) => {
  if (route === '/app/practitioner-dashboard') return import('../PractitionerDashboardPage');
  if (route === '/app/practitioners/offerings') return import('../PractitionerOfferingsPage');
  if (route === '/app/practitioners') return import('../PractitionerPage');
  return Promise.resolve();
};

export default function PractitionerWorkspaceNav({ active = 'patients' }) {
  const navigate = useNavigate();

  const openRoute = (route) => {
    void preloadPractitionerRoute(route);
    navigate(route);
  };

  return (
    <div className="practitioner-workspace-nav-row">
      <button
        type="button"
        className="practitioner-home-button"
        onMouseEnter={() => preloadPractitionerRoute('/app/practitioner-dashboard')}
        onFocus={() => preloadPractitionerRoute('/app/practitioner-dashboard')}
        onClick={() => openRoute('/app/practitioner-dashboard')}
      >
        Home
      </button>

      <nav className="practitioner-workspace-tabs" aria-label="Practitioner workspace">
        {navItems.map((item) => (
          <button
            key={item.id}
            type="button"
            className={active === item.id ? 'active' : ''}
            onMouseEnter={() => preloadPractitionerRoute(item.route)}
            onFocus={() => preloadPractitionerRoute(item.route)}
            onClick={() => openRoute(item.route)}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
